export default "__VITE_ASSET__DuS1e2Fb__"